import Spring from './spring.js';
import {normal} from './springconstants.js';
import mainloop from '../mainloop.js';

export default class SpringSystem {
	constructor(configs, setter) {
		this.springs = Object.create(null);
		this.setter = setter;

		this.running = false;
		this.promise = null;
		this.resolve = null;

		Object.keys(configs).forEach(key => {
			const conf = configs[key];
			let setter, config, margin;
			if (typeof conf === 'function') {
				config = normal;
				setter = conf;
			} else {
				({config = normal, setter, margin} = conf);
			}
			this.springs[key] = new Spring(setter, config, margin);
		});
	}

	setConfig(configs) {
		Object.keys(configs).forEach(key => {
			this.springs[key].config = configs[key];
		});
	}

	stop(resolve = true) {
		if (resolve && this.resolve) {
			this.resolve();
		}
		this.resolve = this.promise = null;
		this.running = false;
		mainloop.removeDelegate(this);
	}

	reset(values) {
		Object.keys(this.springs).forEach(key => {
			const spring = this.springs[key];
			spring.velocity = 0;
			spring.value = values ? values[key] : spring.targetValue;
			spring.setter(spring.value);
		});
		if (this.setter) {
			this.setter();
		}
		this.resolve = this.promise = null;
		this.stop();
	}

	set(values, clearPromise = true) {
		Object.keys(values).forEach(key => {
			const spring = this.springs[key];
			spring.targetValue = values[key];
		});
		if (!this.running) {
			this.running = true;
			mainloop.addDelegate(this);
		}
		if (!this.promise || clearPromise) {
			this.promise = new Promise(resolve => (this.resolve = resolve));
		}
		return this.promise;
	}

	onTick(time) {
		const frameTime = time.delta / 1000;

		let settled = true;
		Object.keys(this.springs).forEach(key => {
			const spring = this.springs[key];

			const step = spring.step(frameTime);
			settled = settled && step;
			spring.setter(spring.value);
		});

		if (this.setter) {
			this.setter();
		}

		if (settled) {
			this.stop();
		}
	}
}



// WEBPACK FOOTER //
// ./lib/pagehandler/math/springsystem.js